import React, { useEffect, useState } from 'react';
import api from '../api';

const STATUS_LABELS = {
  pending:   { label: 'Нове',        bg: '#fff8e8', color: '#8a5e0a' },
  confirmed: { label: 'Підтверджено', bg: '#e8f0ff', color: '#1a3a8a' },
  cooking:   { label: 'Готується',   bg: '#fff0ee', color: '#8a2a1a' },
  ready:     { label: 'Готово',      bg: '#edf5ef', color: '#1a5e2a' },
  done:      { label: 'Видано',      bg: '#f0f0f0', color: '#555' },
  cancelled: { label: 'Скасовано',   bg: '#fdecea', color: '#c0392b' },
};

export default function OrdersPage() {
  const [orders, setOrders]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter]   = useState('all');

  const load = () => {
    api.get('/orders/all').then(r => setOrders(r.data)).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const changeStatus = async (id, status) => {
    await api.patch(`/orders/${id}/status`, { status });
    load();
  };

  const filtered = filter === 'all' ? orders : orders.filter(o => o.status === filter);

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontFamily: "'Fraunces', serif", fontSize: 28, fontWeight: 400 }}>Замовлення</div>
        <div style={{ fontSize: 13, color: 'var(--stone)', marginTop: 4, fontWeight: 300 }}>
          {orders.length} всього · {orders.filter(o => o.status === 'pending').length} нових
        </div>
      </div>

      {/* Filter */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        <button onClick={() => setFilter('all')} style={{
          padding: '6px 14px', borderRadius: 20, fontSize: 12, border: '1px solid',
          borderColor: filter === 'all' ? 'var(--ink)' : 'var(--border)',
          background: filter === 'all' ? 'var(--ink)' : 'transparent',
          color: filter === 'all' ? '#fff' : 'var(--stone)', cursor: 'pointer',
        }}>Всі</button>
        {Object.entries(STATUS_LABELS).map(([key, val]) => (
          <button key={key} onClick={() => setFilter(key)} style={{
            padding: '6px 14px', borderRadius: 20, fontSize: 12, border: '1px solid',
            borderColor: filter === key ? 'var(--ink)' : 'var(--border)',
            background: filter === key ? 'var(--ink)' : 'transparent',
            color: filter === key ? '#fff' : 'var(--stone)', cursor: 'pointer',
          }}>{val.label}</button>
        ))}
      </div>

      {loading ? (
        <div style={{ color: 'var(--stone)', textAlign: 'center', padding: '40px 0' }}>Завантаження...</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {filtered.map(order => {
            const st = STATUS_LABELS[order.status] || STATUS_LABELS.pending;
            return (
              <div key={order.id} className="fade-up" style={{
                background: '#fff', borderRadius: 16, border: '1px solid var(--border)', padding: '18px 20px',
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                      <div style={{ fontFamily: "'Fraunces', serif", fontSize: 16 }}>
                        Замовлення #{order.id}
                      </div>
                      <span style={{ fontSize: 11, fontWeight: 500, padding: '3px 10px', borderRadius: 20, background: st.bg, color: st.color }}>
                        {st.label}
                      </span>
                    </div>
                    <div style={{ fontSize: 12, color: 'var(--stone)', marginBottom: 10 }}>
                      👤 {order.user_name || 'Гість'} · 🪑 Стіл {order.table_num} · 🕐 {new Date(order.created_at).toLocaleString('uk')}
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                      {order.items?.map((item, i) => (
                        <span key={i} style={{
                          background: 'var(--paper)', border: '1px solid var(--border)',
                          borderRadius: 8, padding: '4px 10px', fontSize: 12,
                        }}>
                          {item.emoji} {item.name} × {item.qty}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div style={{ textAlign: 'right', flexShrink: 0 }}>
                    <div style={{ fontFamily: "'Fraunces', serif", fontSize: 20, marginBottom: 10 }}>
                      {order.total} ₴
                    </div>
                    <select
                      value={order.status}
                      onChange={e => changeStatus(order.id, e.target.value)}
                      style={{
                        padding: '7px 10px', borderRadius: 8, border: '1px solid var(--border)',
                        fontSize: 12, background: '#fff', cursor: 'pointer', outline: 'none',
                      }}
                    >
                      {Object.entries(STATUS_LABELS).map(([key, val]) => (
                        <option key={key} value={key}>{val.label}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            );
          })}
          {filtered.length === 0 && (
            <div style={{ textAlign: 'center', padding: '40px 0', color: 'var(--stone)', fontSize: 13 }}>
              Замовлень немає
            </div>
          )}
        </div>
      )}
    </div>
  );
}
